var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.dialogVisible,
        width: "500px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "remark-info" }, [
        _c("p", [_vm._v("对账单号：" + _vm._s(_vm.billInfo.billNo))]),
        _vm._v(" "),
        _c("p", [_vm._v("商家名称：" + _vm._s(_vm.billInfo.merchantName))]),
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        { attrs: { "label-width": "80px", size: "small" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.remarkLabel } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 5,
                  placeholder: "请输入" + _vm.remarkLabel,
                },
                model: {
                  value: _vm.remarkContent,
                  callback: function ($$v) {
                    _vm.remarkContent = $$v
                  },
                  expression: "remarkContent",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _vm._v(" "),
          _c("el-button", { attrs: { type: "primary", size: "small" } }, [
            _vm._v("确 定"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }